import { GatewayQuestionnaire } from "@conformite/gateway";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { QuestionnaireApi } from "../questionnaire.api";
import { questionnaireKeys } from "./questionnaire.keys";

export const useCreateQuestionnaireDefinitionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (
      body: GatewayQuestionnaire.CreateQuestionnaireDefinitionRequestType
    ) => QuestionnaireApi.createDefinition(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: questionnaireKeys.definitions(),
      });
    },
  });
};

export const useUpdateQuestionnaireDefinitionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: string;
      body: GatewayQuestionnaire.UpdateQuestionnaireDefinitionRequestType;
    }) => QuestionnaireApi.updateDefinition(id, body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: questionnaireKeys.definitions(),
      });
    },
  });
};

export const useDeleteQuestionnaireDefinitionMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => QuestionnaireApi.deleteDefinition(id),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: questionnaireKeys.definitions(),
      });
    },
  });
};
